import { useQuery } from '@tanstack/react-query';
import { getAllIpPoolMappings } from 'services/domain';

// eslint-disable-next-line import/prefer-default-export
export const useGetAllIpPoolMappings = () => {
  return useQuery(['ip_pool_mappings'], getAllIpPoolMappings, {
    initialData: [],
  });
};
